import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface SgpTabProps {
  integration: Integration | null;
}

function SgpTab({ integration }: SgpTabProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="sgp_url">URL SGP</FormLabel>
          <FormInput id="sgp_url" name="sgp_url" defaultValue={integration?.sgp_url} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="sgp_token">Token SGP</FormLabel>
          <FormInput id="sgp_token" name="sgp_token" defaultValue={integration?.sgp_token} />
        </FormField>
      </div>

      <FormField>
        <FormLabel htmlFor="sgp_app">Aplicação SGP</FormLabel>
        <FormInput id="sgp_app" name="sgp_app" defaultValue={integration?.sgp_app} />
      </FormField>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="sgp_ocorrenciatipo">ID Tipo de Ocorrência</FormLabel>
          <FormInput
            type="number"
            id="sgp_ocorrenciatipo"
            name="sgp_ocorrenciatipo"
            defaultValue={integration?.sgp_ocorrenciatipo}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="sgp_setor">ID Setor</FormLabel>
          <FormInput
            type="number"
            id="sgp_setor"
            name="sgp_setor"
            defaultValue={integration?.sgp_setor}
          />
        </FormField>
      </div>
    </div>
  );
}

export default SgpTab;
